"use strict";

exports.__esModule = true;
exports.config = void 0;
var config = exports.config = {
  id: "auditLogs",
  name: "AuditLogs",
  element: {
    props: {
      width: 1024,
      height: 768,
      rowCount: 12,
      columnCount: 12,
      timeRangeKind: "multiDay"
    },
    children: [{
      props: {
        dataSource: "AuditLogs",
        gridRowStart: 1,
        gridRowEnd: 13,
        gridColumnStart: 1,
        gridColumnEnd: 13,
        configuration: {
          enablePagination: true,
          overFetchAll: false,
          defaultPageSize: 25,
          enableFetchOnSearch: true,
          enableFetchOnSort: true,
          sort: [{
            property: "created",
            direction: "desc"
          }]
        },
        x: 0,
        y: 0,
        height: 64,
        width: 256
      },
      children: [{
        props: {
          id: "userId",
          name: "User Id",
          type: "string",
          enableSorting: true,
          canSearch: true,
          x: 0,
          y: 0,
          height: 64,
          width: 256
        },
        children: [],
        type: "DataTableColumn"
      }, {
        props: {
          id: "resourceType",
          name: "Resource Type",
          type: "string",
          enableSorting: true,
          canSearch: true,
          x: 0,
          y: 0,
          height: 64,
          width: 256
        },
        children: [],
        type: "DataTableColumn"
      }, {
        props: {
          id: "timestamp",
          name: "Created At",
          type: "date",
          usePlantTime: true,
          enableSorting: true,
          defaultSortOrder: "ASC",
          canSearch: true,
          x: 0,
          y: 0,
          height: 64,
          width: 256
        },
        children: [],
        type: "DataTableColumn"
      }, {
        props: {
          id: "action",
          name: "Action",
          type: "string",
          enableSorting: true,
          canSearch: true,
          x: 0,
          y: 0,
          height: 64,
          width: 256
        },
        children: [],
        type: "DataTableColumn"
      }],
      type: "DataTable"
    }],
    type: "Report"
  }
};